<template>
  <div class="host-matching">
    <h1>主播匹配通话列表</h1>
    <div class="header">
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="currentChannel"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in channels"
          :key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="arrTime"
        align="right"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        class="header-item"
      >
      </el-date-picker>
      <el-button class="header-item" type="primary" @click="Search"
        >查询</el-button
      >
      <el-button
        class="header-item"
        type="primary"
        @click="DownloadFile"
        :loading="isDownload"
        >下载</el-button
      >
    </div>
    <el-table :data="hostMatchList" style="width: 100%" v-loading="loading">
      <el-table-column prop="date" label="日期" width="180"> </el-table-column>
      <el-table-column prop="channel" label="平台" width="180">
      </el-table-column>
      <el-table-column prop="name" label="主播名称" width="180">
      </el-table-column>
      <el-table-column prop="modelName" label="主播机型" width="180">
      </el-table-column>
      <el-table-column prop="agentId" label="代理ID" width="180">
      </el-table-column>
      <el-table-column prop="rid" label="主播ID" width="180"> </el-table-column>
      <el-table-column prop="level" label="主播评级" width="180">
      </el-table-column>
      <el-table-column label="是否新主播" width="180">
        <template slot-scope="scope">
          {{ scope.row.newHost ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column prop="area" label="主播所属地区" width="180">
      </el-table-column>
      <el-table-column prop="country" label="主播所属国家" width="180">
      </el-table-column>
      <el-table-column prop="onlineTime" label="主播在线时长(min)" width="180">
      </el-table-column>
      <el-table-column
        prop="calledMatchUserCount"
        label="用户匹配主播拨打人数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledMatchCount"
        label="用户匹配主播拨打次数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledMatchOKUserCount"
        label="用户匹配主播拨打成功人数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="calledMatchOKCount"
        label="用户匹配主播拨打成功次数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="anchorMatchedTime"
        label="用户匹配主播通话时长(min)"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="anchorMatchedGold"
        label="用户匹配主播通话获得金币数"
        width="180"
      >
      </el-table-column>
      <el-table-column
        prop="anchorMatchedGift"
        label="用户匹配主播通话礼物金币数"
        width="180"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page.sync="currentPage"
      layout="total, prev, pager, next"
      background
      @current-change="handleCurrentChange"
      :total="total"
      class="pagination"
    ></el-pagination>
  </div>
</template>

<script>
import { downloadFile } from '@/utils/downloadFile.js'
import { datainfor } from '@/utils/formdata.js'

export default {
  data() {
    return {
      arrTime: datainfor(1),
      currentPage: 1,
      total: 0,
      currentChannel: 'total',
      loading: true,
      isDownload: false,
      channels: this.$store.state.channels,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      hostMatchList: []
    }
  },
  mounted() {
    this.renderList()
  },
  methods: {
    Search() {
      this.renderList()
    },
    renderList() {
      this.loading = true
      this.$axios({
        method: 'GET',
        url: this.$store.getters.path.host_match,
        withCredentials: true,
        params: {
          start: this.arrTime,
          channel: this.currentChannel,
          page: this.currentPage,
          username: this.$store.getters.username,
          token: this.$store.getters.token
        }
      }).then(res => {
        this.loading = false
        if (res.data.code != 0) return this.$message(res.data.data.msg)
        this.hostMatchList = res.data.data.data
        this.total = res.data.data.total
      })
    },
    DownloadFile() {
      this.isDownload = true
      this.$axios({
        method: 'GET',
        url: this.$store.getters.path.download_host_match_report,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'blob',
        params: {
          start: this.arrTime,
          channel: this.currentChannel,
          page: this.currentPage,
          username: this.$store.getters.username,
          token: this.$store.getters.token
        }
      }).then(res => {
        this.$message.success('开始下载')
        this.isDownload = false
        downloadFile(res.data, '主播匹配通话数据报表')
      })
    },
    handleCurrentChange() {
      this.renderList()
    }
  }
}
</script>

<style scoped>
.host-matching {
  padding: 20px;
}
.header-item {
  margin: 0 5px;
}
h1 {
  margin-bottom: 20px;
  font-size: 28px;
  font-weight: bold;
}
.pagination {
  width: 50%;
  margin: 10px auto;
}
</style>
